const formatPriceNumber = (priceNumber: string | number) => {
  const quantity =
    (typeof priceNumber === 'string'
      ? parseInt(priceNumber, 10)
      : priceNumber) / 100;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(quantity);
};

export default formatPriceNumber;
